var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.app)?_c('div',[(_vm.app.app_version == 2)?_c('EditorV2',{attrs:{"app":_vm.app,"settings":_vm.settings}}):_vm._e(),(_vm.app.app_version >= 3)?_c('EditorV5',{attrs:{"app":_vm.app,"settings":_vm.settings}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }